module.exports = __webpack_public_path__ + "img/28.0fa6025f.jpg";